import React from 'react';
import { Tooltip } from '@mui/material';

function MssTooltip({ children, isOpen, slotProps = {}, title, ...tooltipProps }) {
  const { popper: popperSlotProps = {}, ...otherSlotProps } = slotProps;
  const tooltipChild = React.isValidElement(children) ? children : <span>{children}</span>;

  return (
    <Tooltip
      enterDelay={750}
      leaveDelay={0}
      enterNextDelay={750}
      open={isOpen}
      title={title ?? 'Opens in New Window'}
      arrow
      {...tooltipProps}
      slotProps={{
        ...otherSlotProps,
        popper: {
          ...popperSlotProps,
          modifiers: [
            ...(popperSlotProps.modifiers || []),
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}
    >
      {tooltipChild}
    </Tooltip>
  );
}

export default MssTooltip;
